<template>
  <div class="row justify-start">
    <template v-for="key in keys">
      <div
        :key="key"
        class="col-4 row items-center justify-center"
        :style="['2', '5', '8', '0'].includes(String(key)) ? 'padding: 1px 2px' : 'padding: 1px 0'"
      >
        <q-btn
          :data-testid="`teclado-${key}`"
          :id="`key-${key}`"
          :key="key"
          unelevated
          padding="0"
          :outline="borderer"
          :rounded="borderer"
          @click="handleClick(key)"
          color="grey-12"
          :class="[borderer ? 'buttonBorderer' : 'button', 'col justify-center text-blue-grey-10']"
          :label="key"
        />
      </div>
    </template>

    <slot />

    <div
      v-if="showBackButton"
      class="col-4"
      style="padding: 1px"
    >
      <q-btn
        data-testid="teclado-apagar"
        id="key-back"
        unelevated
        @click="handleBack"
        color="grey-12"
        class="button justify-center text-blue-grey-10"
      >
        <BackIcon class-name="blue-grey-10 " />
        <q-tooltip>Apagar</q-tooltip>
      </q-btn>
    </div>
  </div>
</template>

<script>
import BackIcon from '../assets/icons/back.svg'

export default {
  components: {
    BackIcon
  },

  props: {
    showBackButton: {
      type: Boolean,
      default: false
    },

    borderer: {
      type: Boolean,
      default: false
    }
  },

  data () {
    const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#']
    return { keys }
  },

  methods: {
    handleClick (key) {
      this.$emit('on-key', key)
    },

    handleBack () {
      this.$emit('on-key', null)
    },

    handleKeypress (e) {
      const event = e || window.event
      const mapKeys = { 13: '#', 35: '#', 42: '*', 48: '0', 49: '1', 50: '2', 51: '3', 52: '4', 53: '5', 54: '6', 55: '7', 56: '8', 57: '9' }
      const digit = mapKeys[event.keyCode]
      if (digit) document.getElementById(`key-${digit}`).click()
    },

    handleKeydown (e) {
      if (e.code !== 'Backspace') return
      document.getElementById('key-back')?.click()
    }
  },

  mounted () {
    document.addEventListener('keypress', this.handleKeypress)
    document.addEventListener('keydown', this.handleKeydown)
  },

  destroyed () {
    document.removeEventListener('keypress', this.handleKeypress)
    document.removeEventListener('keydown', this.handleKeydown)
  }
}
</script>

<style lang="sass" scoped>
  .button
    border-radius: 2px
    font-size: 18px
    font-weight: normal
    line-height: 21px
    height: 35px !important
    border: 0
    width: 100%

  .buttonBorderer
    font-size: 18px
    font-weight: normal
    line-height: 21px
    height: 38px !important
    border: 0
    width: 40px !important
</style>
